import React, { useEffect, useState } from "react";
import { Image, Modal } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useAuth } from "../../../../contexts/AuthProvider";
import toursIcon from "../../../../assets/images/tours-icon.png";
import MultipleImage from "../../../../components/multi-img/MultipleImage";
import {
  CostInputField,
  SelectDropDownField,
  TextAreaInputField,
  TextInputField,
  DateTimeField,
  LocationInputField,
} from "../../../../components/form-fields";
import { addTourApi, editTourApi } from "../../../../services/AdminService";
import moment from "moment";
import { getFirstDayAndLastDay } from "../../../../helpers";
import AddressSelector from "../../../../components/search-location/AddressSelector";
import { LoadingSpinnerDotted } from "../../../../components/loading-spinner/Loader";

function ToursModal({
  showToursModal,
  setShowToursModal,
  dayData,
  returnFunction,
  destinationData,
  editable,
  itemData,
}) {
  const { authed, currencyData } = useAuth();
  // Start of Other functions
  const [toursAvatarImg, setToursAvatarImg] = useState([]);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [showSelectMapModal, setShowSelectMapModal] = useState(false);

  const tourTypes = [
    "City Tour",
    "Adventure Tour",
    "Cultural Tour",
    "Food Tour",
    "Nature Tour",
    "Historical Tour",
    "Wildlife Safari",
    "Boat Tour",
    "Hiking Tour",
    "Photography Tour",
    "Shopping Tour",
    "Spa and Wellness Tour",
    "Night Tour",
    "Cruise Tour",
    "Custom Private Tour",
  ];

  const formik = useFormik({
    initialValues: {
      name: itemData?.name || "",
      address: {
        formatted_address: itemData?.address || "",
        lat: itemData?.location?.coordinates[0] || "",
        lng: itemData?.location?.coordinates[1] || "",
      },
      description: itemData?.description || "",
      amount: itemData?.amount || "",
      time: itemData?.time || "",
      tourType: itemData?.types[0] || "",

      checkInTime: editable
        ? moment(itemData.checkInTime).toDate()
        : dayData
          ? moment(dayData?.date).toDate()
          : "",
      checkOutTime: editable ? moment(itemData.checkOutTime).toDate() : dayData ? moment(dayData?.date).toDate() : "",
      websiteLink: itemData?.websiteLink || "",
      status: itemData?.status || "Not Booked",
      currency: editable
        ? itemData?.currency
        : currencyData
          ? currencyData?.currency
          : "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter name."),
      address: Yup.object({
        formatted_address: Yup.string().required("Please enter a location."),
      }),
      tourType: Yup.string().required("Please select tour type."),
      checkInTime: Yup.string().required("Please enter check-in date & time."),
      checkOutTime: Yup.string().required("Please enter check-out date & time.").test(
        "is-greater-time",
        "Check-out time must be after check-in time if on the same day.",
        function (value) {
          const { checkInTime, checkOutTime } = this.parent;
          if (!checkInTime || !value) return true;
          const checkFromTime = moment(checkInTime);
          const checkToTime = moment(checkOutTime);
          if (checkFromTime.isSame(checkToTime, "day")) {
            return checkToTime.isAfter(checkFromTime);
          }
          return true;
        }
      ),
      amount: Yup.string().required("Please enter your expenses."),
      websiteLink: Yup.string()
        .matches(
          /^https:\/\//, "URL must start with https://"
        ).nullable(),
    }),
    onSubmit: async (values) => {
      // console.log("values===>", values);

      const formData = new FormData();
      if (toursAvatarImg.length > 0) {
        toursAvatarImg.forEach((item) => formData.append("icon", item));
      } else {
        if (!editable) formData.append("icon", null);
      }
      formData.append("name", values.name);
      formData.append("address", values.address.formatted_address);
      formData.append("lat", values.address.lat);
      formData.append("lng", values.address.lng);
      formData.append("description", values.description);
      formData.append("amount", values.amount);
      formData.append("currency", values.currency);
      formData.append("types", values.tourType);
      formData.append("checkInTime", values.checkInTime);
      formData.append("checkOutTime", values.checkOutTime);
      formData.append("websiteLink", values.websiteLink);
      formData.append("status", values.status);
      formData.append("time", moment(values.checkInTime).format("HH:mm"));
      formData.append("userId", authed.user._id);
      formData.append("itineraryId", dayData.itineraryId);
      formData.append("daysId", dayData._id);

      setIsLoadingSubmit(true);
      if (editable) {
        formData.append("uniqueIdDayWise", itemData?.uniqueIdDayWise);
        await editTourApi(formData, async (res) => {
          // console.log("res addToursApi ====", res);
          if (res.status === 200) {
            returnFunction();
            setToursAvatarImg([]);
            setShowToursModal(false);
            formik.resetForm();
          } else {
            console.log(
              `Error: ${res.data?.message || "An unexpected error occurred."}`
            );
          }
          setIsLoadingSubmit(false);
        });
      } else {
        await addTourApi(formData, async (res) => {
          // console.log("res addToursApi ====", res);
          if (res.status === 200) {
            returnFunction();
            setToursAvatarImg([]);
            setShowToursModal(false);
            formik.resetForm();
          } else {
            console.log(
              `Error: ${res.data?.message || "An unexpected error occurred."}`
            );
          }
          setIsLoadingSubmit(false);
        });
      }
    },
  });

  const handleToursModalClose = () => {
    setToursAvatarImg([]);
    setShowToursModal(false);
    formik.resetForm();
    setIsLoadingSubmit(false);
  };

  const handleSelectAddress = (results) => {
    // console.log("Selected Address:", results);
    const { address, lat, lng } = results;
    formik.setFieldValue("address", {
      formatted_address: address,
      lat: lat,
      lng: lng,
    });
  };
  // end of Other functions
  useEffect(() => { }, [dayData?.date]);

  useEffect(() => {
    if (itemData) {
      setToursAvatarImg(itemData?.icon);
    }
  }, [itemData]);

  // console.log("=====itemData=======>", editable, itemData);

  return (
    <>
      <Modal
        show={showToursModal}
        onHide={handleToursModalClose}
        keyboard={false}
        size="lg"
        className="add-travellers-modal"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <Image src={toursIcon} width={16} />
            Tours
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={formik.handleSubmit}>
            <div className="row">
              <div className="col-md-12 mb-3">
                <MultipleImage
                  imageList={toursAvatarImg}
                  setImageList={setToursAvatarImg}
                />
              </div>
              <div className="col-md-6 mb-3">
                <TextInputField
                  formik={formik}
                  fieldName="name"
                  labelName="Tour Name"
                  placeHolder="Enter Tour Name"
                />
              </div>
              <div className="col-md-6 mb-3">
                <SelectDropDownField
                  formik={formik}
                  fieldName="tourType"
                  labelName="Tour Type"
                  options={tourTypes}
                />
              </div>
              <div
                className="col-md-12 mb-3"
                onClick={() => {
                  setShowSelectMapModal(true);
                }}
              >
                <LocationInputField
                  formik={formik}
                  objName={"address"}
                  fieldName={"formatted_address"}
                  labelName={"Address"}
                  placeHolder={"Select a location"}
                  disabled={true}
                />
              </div>

              <div className="col-md-6 mb-3">
                <DateTimeField
                  formik={formik}
                  fieldName="checkInTime"
                  labelName="From date & time"
                  disabled={editable}
                  minDate={dayData?.date}
                  maxDate={
                    getFirstDayAndLastDay(destinationData?.itineraryDatys)
                      ?.lastDate
                  }
                  type="from"
                />
              </div>
              <div className="col-md-6 mb-3">
                <DateTimeField
                  formik={formik}
                  fieldName="checkOutTime"
                  labelName="To date & time"
                  disabled={editable}
                  minDate={dayData?.date}
                  type={editable ? "to" : false}
                  maxDate={
                    getFirstDayAndLastDay(destinationData?.itineraryDatys)
                      ?.lastDate
                  }
                />
              </div>

              <div className="col-md-6 mb-3">
                <CostInputField
                  formik={formik}
                  fieldName="amount"
                  labelName="Estimated Cost (Per Day)"
                  currency={currencyData}
                  placeHolder="Enter Cost"
                />
              </div>

              <div className="col-md-6 mb-3">
                <SelectDropDownField
                  formik={formik}
                  fieldName="status"
                  labelName="Status"
                  options={["Not Booked", "Booked"]}
                />
              </div>

              <div className="col-md-12 mb-3">
                <TextInputField
                  formik={formik}
                  fieldName="websiteLink"
                  labelName="Website URL"
                  placeHolder="Enter Website URL"
                />
              </div>

              <div className="col-md-12">
                <TextAreaInputField
                  formik={formik}
                  fieldName="description"
                  labelName="Description"
                  placeHolder="Enter Description"
                />
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="pt-2 pb-2 justify-content-center">
          <button
            type="button"
            onClick={handleToursModalClose}
            className="btn btn-secondary-color btn-border-color me-0"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={(e) => formik.handleSubmit()}
            className="btn btn-primary-color btn-border-color ms-3"
            disabled={isLoadingSubmit === true}
          >
            {isLoadingSubmit ? <LoadingSpinnerDotted /> : "Submit"}
          </button>
        </Modal.Footer>
      </Modal>

      <AddressSelector
        showModal={showSelectMapModal}
        setShowModal={setShowSelectMapModal}
        addressData={formik.values.address}
        onSelectAddress={(address) => handleSelectAddress(address)}
        destination={destinationData?.destination_city}
      />
    </>
  );
}

export default ToursModal;
